import { render, staticRenderFns } from "./AddressLivraisonDesk.vue?vue&type=template&id=76be0b70&"
import script from "./AddressLivraisonDesk.vue?vue&type=script&lang=js&"
export * from "./AddressLivraisonDesk.vue?vue&type=script&lang=js&"
import style0 from "./AddressLivraisonDesk.vue?vue&type=style&index=0&id=76be0b70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports